import { HttpHandler } from 'msw'

import { rebootApt } from './rebootApt'

export const reboot: HttpHandler[] = [rebootApt]
